import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
const viteComponents = import.meta.glob("../views/**/*.vue");

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../views/Login.vue"),
      meta: {
        title: "政策通平台-上海市老年基金会_登录",
      },
    },
    
    {
      path: "/contactUs",
      name: "ContactUs",
      component: viteComponents["../views/ContactUs.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_联系我们",
      },
    },
    {
      path: "/aboutUs",
      name: "AboutUs",
      component: viteComponents["../views/AboutUs.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_关于我们",
      },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/login",
    },
  ],
});

export function resetRouter(action: string) {
  let myRoutes = [
    {
      path: "/policyLibrary",
      name: "PolicyLibrary",
      component: viteComponents["../views/PolicyLibrary.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_政策导航",
      },
    },
    {
      path: "/home",
      name: "Home",
      component: viteComponents["../views/Home.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_首页",
      },
    },
    {
      path: "/home/industryMap",
      name: "IndustryMap",
      component: viteComponents["../views/IndustryMap.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_产业图谱",
      },
    },
    {
      path: "/home/strategicFramework",
      name: "StrategicFramework",
      component: viteComponents["../views/StrategicFramework.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_一本讲话",
      },
    },
    {
      path: "/home/strategicFramework/:id",
      name: "StrategicFrameworkDetail",
      component: viteComponents["../views/StrategicFrameworkDetail.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_一本讲话详情",
      },
    },
    {
      path: "/home/freeTradeFeatures",
      name: "FreeTradeFeatures",
      component: viteComponents["../views/FreeTradeFeatures.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_自贸特色",
      },
    },
    {
      path: "/home/freeTradeFeatures/:id",
      name: "FreeTradeFeaturesDetail",
      component: viteComponents["../views/FreeTradeFeaturesDetail.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_自贸特色政策专题",
      },
    },
    {
      path: "/policyLibrary/:id",
      name: "PolicyLibraryDetail",
      component: viteComponents["../views/PolicyLibraryDetail.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_政策导航",
      },
    },
    {
      path: "/policyNavigation/:id",
      name: "PolicyMavogationDetail",
      component: viteComponents["../views/PolicyNavigationDetail.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_风险解读",
      },
    },
    {
      path: "/policyLibraryText/:id",
      name: "PolicyLibraryText",
      component: viteComponents["../views/PolicyLibraryText.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_政策解读详情",
      },
    },
    {
      path: "/policyMatching",
      name: "PolicyMatching",
      component: viteComponents["../views/PolicyMatching.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_基金会制度",
      },
    },
    {
      path: "/policyMatching/:id",
      name: "PolicyMatchingDetail",
      component: viteComponents["../views/PolicyMatchingDetail.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_基金会制度详情",
      },
    },
    {
      path: "/dataBrain",
      name: "DataBrain",
      component: viteComponents["../views/DataBrain.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_风险解读",
      },
    },
    {
      path: "/search",
      name: "Search",
      component: viteComponents["../views/Search.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_首页搜索",
      },
    },
    {
      path: "/policyCollection",
      name: "PolicyCollection",
      component: viteComponents["../views/PolicyCollection.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_我的收藏",
      },
    },
    {
      path: "/browseRecords",
      name: "BrowseRecords",
      component: viteComponents["../views/BrowseRecords.vue"],
      meta: {
        title: "政策通平台-上海市老年基金会_浏览记录",
      },
    },
  ];

  if (action == "add") {
    for (let i = 0; i < myRoutes.length; i++) {
      router.addRoute(myRoutes[i]);
    }
  } else {
    for (let i = 0; i < myRoutes.length; i++) {
      if (router.hasRoute(myRoutes[i].name)) {
        router.removeRoute(myRoutes[i].name);
      }
    }
  }
}

export default router;
